import { AutogenModelEdigenericProfile, AutogenRowEdigenericProfile } from "./autogen/AutogenModelEdigenericProfile";

export class ModelEdigenericProfile extends AutogenModelEdigenericProfile<RowEdigenericProfile> {
	constructor() {
		super(RowEdigenericProfile);
	}
}

export class RowEdigenericProfile extends AutogenRowEdigenericProfile {
}